import {Injectable} from '@angular/core';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {TtmTicketService} from '../../services/ttm-ticket.service';
// import {MatPaginator} from '@angular/material/paginator';
import {TtmTicket} from '../../classes/ttm-ticket.class';

@Injectable({
    providedIn: 'root'
})
export class TtmTicketDataSource implements DataSource<TtmTicket> {

    private ticketSubject = new BehaviorSubject<TtmTicket[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    orderBy = 'created_at';
    orderDirection = 'desc';
    searchTerm?: string;
    assigneeId?: number;
    offset = 0;
    pageSize = 20;
    length = 0;
    private sourceSubscription: Subscription;

    constructor(private ttmTicketService: TtmTicketService) {

    }

    public get tickets$(): Observable<TtmTicket[]> {
        return this.ticketSubject.asObservable();
    }

    public setSorting(orderBy: string, orderDirection: 'asc' | 'desc') {
        this.orderBy = orderBy;
        this.orderDirection = orderDirection;
    }



    public set searchString(searchString: string) {
        this.searchTerm = searchString;
    }

    public set assigneeIdFilter(assigneeId: number | undefined) {
        this.assigneeId = assigneeId;
    }

    resetTickets() {
        this.offset = 0;
        this.length = 0;
        this.ticketSubject.next([]);
    }

    /**
     * Laad meer tickets voor infinite scroll.
     * Geeft Observable<boolean> terug: true als alles geladen is.
     */
    loadMoreTickets({orderBy, orderDirection, search, assigneeId, pageSize, reset = false}: {
        orderBy: string,
        orderDirection: 'asc' | 'desc',
        search?: string,
        assigneeId?: number,
        pageSize: number,
        reset?: boolean
    }) {
        this.orderBy = orderBy;
        this.orderDirection = orderDirection;
        this.searchTerm = search;
        this.assigneeId = assigneeId;
        this.pageSize = pageSize;
        if (reset) {
            this.offset = 0;
            this.ticketSubject.next([]);
        }
        this.loadingSubject.next(true);
        return new Observable<boolean>(observer => {
            this.sourceSubscription?.unsubscribe();
            this.sourceSubscription = this.ttmTicketService.getTickets(
                this.orderBy,
                this.orderDirection || 'asc',
                this.searchTerm,
                this.offset,
                this.pageSize,
                this.assigneeId
            ).subscribe({
                next: tickets => {
                    const current = reset ? [] : this.ticketSubject.value;
                    const newTickets = tickets.data || [];
                    this.ticketSubject.next([...current, ...newTickets]);
                    this.length = tickets.length;
                    this.offset += newTickets.length;
                    this.loadingSubject.next(false);
                    // Als minder dan pageSize terugkomt, is alles geladen
                    const allLoaded = newTickets.length < this.pageSize || this.offset >= this.length;
                    observer.next(allLoaded);
                    observer.complete();
                },
                error: () => {
                    this.loadingSubject.next(false);
                    observer.next(true);
                    observer.complete();
                }
            });
        });
    }

    connect(collectionViewer: CollectionViewer): Observable<TtmTicket[] | ReadonlyArray<TtmTicket>> {
        return this.ticketSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.ticketSubject.complete();
        this.loadingSubject.complete();
        this.sourceSubscription?.unsubscribe();
    }
}
